module.exports = "/images/vendor/flag-icon-css/flags/4x3/tt.svg?c3647d9bc890d2ebd383b80a3812e52f";